import { memo } from 'react';
import { useNotification } from 'useCases/notification';
// TODO handle connection with notifications socket
export const NotificationsWatcher = memo(() => {
  useNotification();
  return null;
});
